import ztComponent from './ztTooltip.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
